/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_OnboardingInputs */

const en_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding`)
};

const ar_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعريف بالمنتج`)
};

const bn_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অনবোর্ডিং`)
};

const de_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onboarding`)
};

const es_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporación`)
};

const fr_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégration`)
};

const pt_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integração`)
};

const zh_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入职`)
};

const tr_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlk Katılım`)
};

const ru_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрация`)
};

const pl_svchip_onboarding = /** @type {(inputs: Svchip_OnboardingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wdrożenie`)
};

/**
* | output |
* | --- |
* | "Onboarding" |
*
* @param {Svchip_OnboardingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_onboarding = /** @type {((inputs?: Svchip_OnboardingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_OnboardingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_onboarding(inputs)
	if (locale === "bn") return bn_svchip_onboarding(inputs)
	if (locale === "de") return de_svchip_onboarding(inputs)
	if (locale === "es") return es_svchip_onboarding(inputs)
	if (locale === "fr") return fr_svchip_onboarding(inputs)
	if (locale === "pt") return pt_svchip_onboarding(inputs)
	if (locale === "zh") return zh_svchip_onboarding(inputs)
	if (locale === "tr") return tr_svchip_onboarding(inputs)
	if (locale === "ru") return ru_svchip_onboarding(inputs)
	if (locale === "pl") return pl_svchip_onboarding(inputs)
	return en_svchip_onboarding(inputs)
});